/**
 * Assigned-courses page.
 */
import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import MuiDrawer from '@mui/material/Drawer';
import { Box, Tabs, Tab, Grid, Divider, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { VText, VButton } from "form";
import { useAsterController } from "context";
import AssignedAll from './assigned.all';
import AssignedCourse from './assigned.course';
import AssignedVirtual from './assigned.virtual';

/**
 * Tabbed view of all assigned courses, including virtual sessions.
 */
const Assigned = () => {

  const { t } = useTranslation('common');

  const [controller] = useAsterController();
  const { mobile } = controller;

  const [tab, setTab] = useState(0);
  const [wrap, setWrap] = useState(true);

  useEffect(() => mobile && setTab(0), [mobile]);

  const handleSetTabValue = (_, newValue) => setTab(newValue);

  return <>

    <MuiDrawer anchor="left" open={!wrap} onClose={() => setWrap(!wrap)} >
      <Box className="v-header w-60">
        <VButton variant="text" color="secondary" className={`text-sm normal-case w-full my-1 text-black justify-start py-3 pl-5 ${tab === 0 ? 'v-bg-side-active' : ""}`} onClick={() => setTab(0)}>{t("All Contents")}</VButton>
        <VButton variant="text" color="secondary" className={`text-sm normal-case w-full my-1 text-black justify-start py-3 pl-5 ${tab === 1 ? 'v-bg-side-active' : ""}`} onClick={() => setTab(1)}>{t("Course")}</VButton>
        <VButton variant="text" color="secondary" className={`text-sm normal-case w-full my-1 text-black justify-start py-3 pl-5 ${tab === 2 ? 'v-bg-side-active' : ""}`} onClick={() => setTab(2)}>{t("Virtual Class")}</VButton>
      </Box>
    </MuiDrawer>

    <Box className="m-0 md:m-6 v-bg-body rounded-none md:rounded-md flex-1">
      <Box className="mx-auto">
        <Box className="md:px-14 px-4 pt-8" id="v-chat-title">
          <Grid container spacing={2}>
            <Grid item xs={4} className="flex items-center">
              <VText className="text-2xl md:text-4xl">{t("Assigned")}</VText>&nbsp;
            </Grid>
            <Grid item xs={8} className="hidden md:flex justify-center md:justify-end flex-wrap items-center">
              <Link to="/explore" className="no-underline ml-4">
                <VButton variant="contained" color="primary" className="text-sm normal-case my-1 px-10 py-3">{t("Explore Content")}</VButton>
              </Link>
            </Grid>
            <Grid item xs={8} className="flex md:hidden justify-end items-center">
              <IconButton component="label" onClick={() => setWrap(false)}>
                <Icon icon="heroicons-solid:menu-alt-1" />
              </IconButton>
            </Grid>
          </Grid>
          <Tabs orientation="horizontal" value={tab} onChange={handleSetTabValue} sx={{ minHeight: 36 }} className="hidden md:flex assigned_tab mt-2 h-9 v-tabs">
            <Tab label={t("All Contents")} className="min-h-0 text-dark normal-case" />
            <Tab label={t("Course")} className="min-h-0 text-dark normal-case" />
            <Tab label={t("Virtual Class")} className="min-h-0 text-dark normal-case" />
          </Tabs>
        </Box>

        <Divider className="bg-gray-200 dark:bg-gray-500 hidden md:flex" />

        {tab === 0 && <AssignedAll />}
        {tab === 1 && <AssignedCourse />}
        {tab === 2 && <AssignedVirtual />}
      </Box>
    </Box>
  </>;
};

export default Assigned;